var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndometrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 8,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2192 4.12012H5.69922V20.3701H12.2192V4.12012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2194 4.87012C11.2994 4.87012 9.6194 5.13012 9.6194 5.13012C8.7494 5.30012 7.90939 5.69012 7.29939 6.33012C6.71939 6.93012 6.5294 7.30012 6.4694 8.34012C6.4694 8.34012 6.0694 10.7201 8.5294 11.8201C9.6294 12.3901 10.3394 13.5101 10.3794 14.7401L10.4294 16.2101L10.4694 16.7701L10.7894 19.6201",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 4,
    width: 7,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7407 4.12012H12.2207V20.3701H18.7407V4.12012Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2207 4.87012C13.1407 4.87012 14.8207 5.13012 14.8207 5.13012C15.6907 5.30012 16.5307 5.69012 17.1407 6.33012C17.7207 6.93012 17.9107 7.30012 17.9707 8.34012C17.9707 8.34012 18.3707 10.7201 15.9107 11.8201C14.8107 12.3901 14.1007 13.5101 14.0607 14.7401L14.0107 16.2101L13.9707 16.7701L13.6507 19.6201",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2071_20530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 11,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 4H2V13.12H12.23V4Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2071_20530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.76992 11.8302C2.67992 10.8402 3.03993 9.48024 3.33993 8.78024C3.63993 8.08024 4.1799 7.46023 5.0999 6.82023C5.3399 6.65023 6.7399 5.87024 7.6299 5.52024C7.8199 5.45024 9.13991 5.13023 9.63991 4.99023C9.74991 4.96023 11.2599 4.78024 11.2599 4.78024L12.3699 4.74023",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23053 12.3707C3.23053 12.3707 2.07054 12.1707 3.34054 9.13067C3.77054 8.11067 4.47053 12.0907 3.23053 12.3707Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15039 8.62988C9.15039 8.62988 12.2904 9.94988 12.2204 11.4199",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2071_20530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 4,
    width: 11,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4507 4H12.2207V13.12H22.4507V4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2071_20530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6703 11.8302C21.7603 10.8402 21.4003 9.48024 21.1003 8.78024C20.8003 8.08024 20.2603 7.46023 19.3403 6.82023C19.1003 6.65023 17.7003 5.87024 16.8103 5.52024C16.6203 5.45024 15.3003 5.13023 14.8003 4.99023C14.6903 4.96023 13.1803 4.78024 13.1803 4.78024L12.0703 4.74023",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.221 12.3707C21.221 12.3707 22.381 12.1707 21.111 9.13067C20.681 8.11067 19.981 12.0907 21.221 12.3707Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2899 8.62988C15.2899 8.62988 12.1499 9.94988 12.2199 11.4199",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndometrial);
export default __webpack_public_path__ + "static/media/Endometrial.88fdadb2b3eb66013c8e0e66c3429ce3.svg";
export { ForwardRef as ReactComponent };